import {Route, Switch} from 'react-router-dom'
import Header from './Header'
import About from './About'
import Portfolio from './Portfolio'
import Testimonials from './Testimonials'
import Footer from './Footer'
import Rezum from './Rezum'
import Hivec from './Hivec'
import Eswt from './Eswt'
import Optilume from './Optilume'
import Privacy from './Privacy'
import Impressum from './Impressum'
import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import HeaderWithReturn from './HeaderWithReturn'
import PagesFooter from './PagesFooter'
import SpaceOAR from './SpaceOAR'
import Urolift from "./Urolift/Urolift";
import Itind from "./Itind/Itind";
import Peyronie from "./Peyronie/Peyronie";
import ContactForm from "./ContactForm";
import Article from "./Article";
import Papers from "./Papers";
import Ambassador from "./Ambassador";
import Uro from './Uro'
import Bph from './Bph'
import Optilume_BPH from './Optilume_BPH'
import Prostate from './Prostate'
import KidneyHealth from './KidneyHealth'
import TesticularHealth from './TesticularHealth'
import HealthyBladder from './HealthyBladder'
import Schokwave from './Schokwave/Schokwave'
import HIFEM from './HIFEM/HIFEM'
 

const Structure = (data) => {
    const {i18n} = useTranslation()
    const language = useSelector(state => state.language)

    useEffect(() => {
        if (language && language !== i18n.language) {
            i18n.changeLanguage(language)
        }
        window.scrollTo(0, 0)
    })
    return (
        <Switch>
            <Route exact path="/">
                <Header/>
                <About/>
                {/*<Resume info={data.resumeData.resume}/>*/}
                <Portfolio/>
                <Testimonials/>
                <ContactForm/>
                <Footer/>
            </Route>
            <Route exact path="/home">
                <Header/>
                <About/>
                {/*<Resume info={data.resumeData.resume}/>*/}
                <Portfolio/>
                <Testimonials/>
                <ContactForm/>
                <Footer/>
            </Route>
            <Route path="/rezum">
                <HeaderWithReturn/>
                <Rezum />
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path='/space-oar'>
                <HeaderWithReturn/>
                <SpaceOAR/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/hivec">
                <HeaderWithReturn/>
                <Hivec/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/eswt">
                <HeaderWithReturn/>
                <Eswt/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/optilume">
                <HeaderWithReturn/>
                <Optilume/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/article-1">
                <HeaderWithReturn/>
                <Article/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/papers">
                <HeaderWithReturn/>
                <Papers/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/ambassador">
                <HeaderWithReturn/>
                <Ambassador/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/privacy">
                <Privacy/>
                <ContactForm/>
                <Footer/>
            </Route>
            <Route path="/impressum">
                <Impressum/>
                <ContactForm/>
                <Footer/>
            </Route>
            <Route path="/urolift">
                <HeaderWithReturn/>
                <Urolift/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/itind">
                <HeaderWithReturn/>
                <Itind/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/peyronie">
                <HeaderWithReturn/>
                <Peyronie/>
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/Uro">
                <HeaderWithReturn/>
                <Uro />
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/Prostate">
                <HeaderWithReturn/>
                <Prostate />
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/KidneyHealth">
                <HeaderWithReturn/>
                <KidneyHealth />
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/TesticularHealth">
                <HeaderWithReturn/>
                <TesticularHealth />
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/HealthyBladder">
                <HeaderWithReturn/>
                <HealthyBladder />
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/Schokwave">
                <HeaderWithReturn/>
                <Schokwave />
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/HIFEM">
                <HeaderWithReturn/>
                <HIFEM />
                <ContactForm/>
                <PagesFooter/>
            </Route>
            <Route path="/Bph">
                <HeaderWithReturn/>
                <Bph />
                <ContactForm/>
                <PagesFooter/>
            </Route>     
             <Route path="/Optilume_BPH">
                <HeaderWithReturn/>
                <Optilume_BPH />
                <ContactForm/>
                <PagesFooter/>
            </Route>             
                  
        </Switch>
    )
}

export default Structure



// WEBPACK FOOTER //
// ./src/Components/Structure.js